"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationShopStatus',
  data: function data() {
    return {
      loading: false,
      status: {
        open: true,
        actions: []
      },
      logs: []
    };
  },
  created: function created() {
    this.reload();
  },
  methods: {
    actionText: function actionText(value) {
      return {
        close: '歇业关店',
        reopen: '立即复业'
      }[value] || value;
    },
    reload: function reload() {
      var _this = this;
      this.loading = true;
      Promise.all([(0, _decoration.decorationShopStatusApi)(), (0, _decoration.decorationShopStatusLogsApi)({
        page: 1,
        limit: 20
      })]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          status = _ref2[0],
          page = _ref2[1];
        _this.status = status || {
          open: true,
          actions: []
        };
        _this.logs = page && page.list || [];
      }).finally(function () {
        _this.loading = false;
      });
    },
    runAction: function runAction(action) {
      var _this2 = this;
      var needReason = action === 'close';
      var runner = needReason ? this.$prompt('关店原因', '确认歇业关店').then(function (_ref3) {
        var value = _ref3.value;
        return {
          action: action,
          reason: value
        };
      }) : this.$confirm('确认复业？').then(function () {
        return {
          action: action
        };
      });
      runner.then(function (payload) {
        return (0, _decoration.decorationShopStatusActionApi)(payload);
      }).then(function () {
        _this2.$message.success('已更新');
        _this2.reload();
      }).catch(function () {});
    }
  }
};